/**
 * ItxProductPageCmp
 */

//jshint ignore:start
(function() {
    
    'use strict';

    var ItxProductPageCmp = {
        bindings: {
            productId: '<',
            colorId: '<',
            product: '<',
            products: '<',
            productIndex: '<',
            isLast:'<',
            isFirst:'<',
            showProductNavigation:'<',
            nextProduct:'&',
            prevProduct:'&',
            showCategory:'&',
            onNavigateToProduct: '&',
            onProductColorChanged: '&'
        },
        controller: ItxProductPageCmpCtrl,
        templateUrl: 'ItxProductPageCmp.html'
    };
    
    angular.module('itxApp.catalog').component('itxProductPage', ItxProductPageCmp);

    ItxProductPageCmpCtrl.$inject = [
        '$rootScope',
        '$timeout',
        'ItxScreenSizeSvc',
        'CmsConfigSvc',
        'imGridService'
    ];

    function ItxProductPageCmpCtrl(
        $rootScope,
        $timeout,
        ItxScreenSizeSvc,
        CmsConfigSvc,
        imGridService
    ) {

        var _this = this;

        _this.productLoaded = false;
        _this.showRelateds = false;   
        _this.ItxScreenSizeSvc = ItxScreenSizeSvc;

        _this.back = function () {
            _this.showCategory({});
            imGridService.sendPageView();
        };

        _this.next = function () {
            _this.nextProduct({});
        };
        
        _this.prev = function () {
             _this.prevProduct({});
        };

        _this.productName = function () {
            return this.product.activeDetail.name;
        };
        
        _this.$onInit = function () {

            CmsConfigSvc.getProperty('show_related_products').then(function(showRelateds) {
                _this.showRelateds = showRelateds;
            });  

            _this.addEventScrollClass();
        };

        _this.onProductClicked = function (product) {
            _this.onNavigateToProduct({product:product});
        };

        _this.changeColor = function (color) {
            _this.showRelateds = false;
            _this.onProductColorChanged({color:color});
            $timeout(function (params) {
                _this.showRelateds = true;
            });
        };

        _this.toggleClassScroll = function(param){
            if(param){
                $('body ').addClass('contract-minibtn');    
            } else {
                $('body').removeClass('contract-minibtn');
            }
        };

        _this.addEventScrollClass = function() {
            if(ItxScreenSizeSvc.is('xs,sm') && joyr.catalog.utils.isOpenForSale() && inditex.iPage === 'ItxProductPage'){
                $(window).on("load", _this.eventClassMiniBtn);
                $(window).scroll( _this.eventClassMiniBtn );
            }
        };

        _this.eventClassMiniBtn = function () {
            var h = $(window).height();
            var first = $(".js-scroll-element-first").offset();
            var second = $(".js-scroll-element-second").offset();
            var scroll = $(window).scrollTop();
            
            if(first && second){
                // Button bundle
                if( scroll <= (second.top - (h-100)) ) {
                    _this.toggleClassScroll('add');
                } else {
                    _this.toggleClassScroll()
                }
            } else if(first) {
                // Button producT
                (scroll >= first.top) ? _this.toggleClassScroll('add'): _this.toggleClassScroll();
            } else {
                _this.toggleClassScroll()
            }
        };

    }

})();